/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_P3tInputs */

const en_mk_sol_operasional_p3t = /** @type {(inputs: Mk_Sol_Operasional_P3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No record of who approved what`)
};

const id_mk_sol_operasional_p3t = /** @type {(inputs: Mk_Sol_Operasional_P3tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada catatan siapa menyetujui apa`)
};

/**
* | output |
* | --- |
* | "No record of who approved what" |
*
* @param {Mk_Sol_Operasional_P3tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_p3t = /** @type {((inputs?: Mk_Sol_Operasional_P3tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_P3tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_p3t(inputs)
	return en_mk_sol_operasional_p3t(inputs)
});